import { Box, Typography } from '@mui/material';

type TransactionItemProps = {
  label: string;
  value: string;
};

const TransactionItem = ({ label, value }: TransactionItemProps) => {
  return (
    <Box
      display="flex"
      flexDirection="row"
      justifyContent="space-between"
      mt={0.5}
      data-testid="TransactionItem.Row"
    >
      <Typography data-testid="TransactionItem.Row.Label">{label}</Typography>
      <Typography data-testid="TransactionItem.Row.Value">{value}</Typography>
    </Box>
  );
};

export default TransactionItem;
